import clsx from "clsx";
import { ReactMarkdown } from "react-markdown/lib/react-markdown";
import LCountDownTimer from "../lcount-down-timer/LCountDownTimer";
import parse from "html-react-parser";
import Image from "next/image";

/* eslint-disable-next-line */
export interface LLigghtWithTopImageProps {
  id?: string;
  topTitle?: string;
  mainTitle?: string;
  textContent?: string; // rich text
  topImage?: {
    imgUrl: string;
    altTag: string;
  };
  centerText?: boolean;
  countDownTimer?: {
    endDate: Date;
    description?: string;
  };
}

export function LLigghtWithTopImage(props: LLigghtWithTopImageProps) {
  return (
    <div className="py-10 bg-eklight" id={props?.id}>
      {props?.topImage?.imgUrl && (
        <Image
          src={props?.topImage?.imgUrl}
          alt={props?.topImage?.altTag || "image"}
          className="object-cover w-full h-full"
          width={1920}
          height={1080}
          quality={80}
        />
      )}

      <div
        className={clsx([
          props?.centerText && "text-center items-center",
          "container flex flex-col gap-5 px-4 mx-auto mt-10 lg:max-w-5xl",
        ])}
      >
        <div className="space-y-5">
          {props?.topTitle && (
            <div className="-mb-5 text-xl font-semibold text-ekgreen">
              {props?.topTitle}
            </div>
          )}

          <h1>{parse(props?.mainTitle ?? "")}</h1>
          {props.textContent && (
            <ReactMarkdown>{props.textContent}</ReactMarkdown>
          )}
        </div>
        {props?.countDownTimer && (
          <div>
            <LCountDownTimer
              endDate={new Date(props?.countDownTimer?.endDate)}
              description={props?.countDownTimer?.description}
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default LLigghtWithTopImage;
